import React from "react";
import Category from "./components/Category";
import Brand from "./components/Brand";
import Model from "./components/Model";
import EquipmentList from "./components/EquipmentList";
import Box from "@mui/material/Box";

const Equipments = () => {
  return (
    <Box sx={{ width: "100%", mt: 4 }}>
      {/* Üstte yan yana üç component */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          justifyContent: "flex-start",
        }}
      >
        <Category />
        <Brand />
      </Box>
      <Box sx={{ width: "100%" }}>
        <Model />
      </Box>
      {/* Altta tam genişlikte liste */}
      <Box sx={{ width: "100%" }} mt={4}>
        <EquipmentList />
      </Box>
    </Box>
  );
};

export default Equipments;
